export default "__VITE_ASSET__aJwuNaa___"